import { Radio } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import styles from '../styles/Activity.module.scss';
import { EnumLikelihood } from './EnumLikelihood';

type Props = {
  value?: string;
  setValue?: (value: string) => void;
  name: string;
  disabled?: boolean;
};

const RiskRadioButtonLikelihood = ({ value, setValue, name, disabled }: Props) => {
  const { t } = useTranslation();

  const handleOptionChange = (e: any, { value }: Props) => {
    if (setValue && value) {
      setValue(value);
    }
  };

  return (
    <div className={styles.flexContainer}>
      <div className={styles.checkboxOption}>
        <Radio
          label={t('risk.assessment.details.page.risk.details.container.table.high')}
          name={name}
          value={`${EnumLikelihood.HIGH}`}
          checked={value === `${EnumLikelihood.HIGH}`}
          onChange={handleOptionChange}
          disabled={disabled}
        />
      </div>
      <div className={styles.checkboxOption}>
        <Radio
          label={t('risk.assessment.details.page.risk.details.container.table.medium')}
          name={name}
          value={`${EnumLikelihood.MEDIUM}`}
          checked={value === `${EnumLikelihood.MEDIUM}`}
          onChange={handleOptionChange}
          disabled={disabled}
        />
      </div>
      <div className={styles.checkboxOption}>
        <Radio
          label={t('risk.assessment.details.page.risk.details.container.table.low')}
          name={name}
          value={`${EnumLikelihood.LOW}`}
          checked={value === `${EnumLikelihood.LOW}`}
          onChange={handleOptionChange}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default RiskRadioButtonLikelihood;
